export default "__VITE_ASSET__be672dc6__"